/**
 * Keep Tab inside a modal surface (Sheet, FlowShell, #1779 A1): call from the
 * surface's keydown handler. Shift+Tab on the first visible focusable element
 * wraps to the last, Tab on the last wraps to the first; anything else is left
 * to the browser.
 */
const FOCUSABLE = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * @param {HTMLElement|null|undefined} container
 * @param {KeyboardEvent|{ key: string, shiftKey: boolean, preventDefault: Function }} event
 */
export function trapTabWithin(container, event) {
  if (event.key !== 'Tab' || !container) return;
  // Visible only: getClientRects() is empty for display:none (and in jsdom,
  // which makes this a no-op in unit tests, as intended).
  const list = Array.from(container.querySelectorAll(FOCUSABLE)).filter((n) => n.getClientRects().length > 0);
  if (list.length === 0) return;
  const first = list[0];
  const last = list[list.length - 1];
  const active = document.activeElement;
  if (event.shiftKey && (active === first || active === container)) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && active === last) {
    event.preventDefault();
    first.focus();
  }
}
